const hero = {
  name: "I'm Eduard Hvizdak.",
  tagline:
    'I build AI agents and automation systems that run in production. Real systems that save your team hours every week: scoped, built, and delivered end to end.',
  viewProjects: 'View projects',
  emailMe: 'Email me',
  accepting: 'Accepting new projects',
};

export default hero;
